<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar color="white">              
              <v-select solo flat style="max-width:250px"
                 v-bind:items="gedungs"
                 item-text="nama"
                 item-value="id"
                 v-model="filter.gedung_id"
                 label="-select gedung-"                 
               ></v-select>  
              <v-spacer></v-spacer>              
            </v-toolbar>           
            <v-card-text class="pa-0 ma-0">
              <v-progress-linear slot="progress" color="blue" class="ma-0" indeterminate v-if="loading"></v-progress-linear>                   
            </v-card-text>
            <v-card-text :style="gedung.color ? 'background:'+gedung.color:''">                            
              <v-layout row wrap v-if="gedung.childs">
                <v-flex lg6 sm12 xs12 v-for="(ruang, i) in gedung.childs" v-bind:key="i">
                  <v-card>
                    <v-toolbar dense cad :set="no=1">
                      <v-toolbar-title>{{ruang.nama}}</v-toolbar-title>
                      <v-spacer/>
                      <v-btn @click="openDialogGrid(gedung.color,ruang)" icon><v-icon>dashboard</v-icon></v-btn>
                      <v-btn @click="openDialogList(gedung.color,ruang)" icon><v-icon>list</v-icon></v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0 block"  :set2="start=true">                      
                      <table style="width:100%">
                        <tbody>
                          <template>
                            <tr v-for="(n) in 20" :key="n" v-if="start">
                              <template v-for="(j) in 5" v-if="no<=ruang.kapasitas">
                                <td class="text-xs-center" :key="j" :set="start = no<=ruang.kapasitas? true :false" :style="ruang.calons[no-1]?'background:#14BE3E':''">
                                  <template v-if="ruang.calons[no-1]">
                                    <router-link :to="{path:'/calon/card', query:{id:ruang.calons[no-1].user_id}}" target="_blank">
                                      <span class="white--text">
                                        <strong>{{ruang.calons[no-1].number}}</strong><br/>
                                        <small>{{ruang.calons[no-1].nama}}</small>
                                      </span>                                      
                                    </router-link>
                                  </template>  
                                  <template v-else>
                                    <span style="font-size:8px" class="grey--text">{{no}}</span>
                                  </template>                                    
                                  <span :set="no++"></span>
                                </td>
                              </template>
                            </tr>
                          </template>                          
                        </tbody>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>              
            </v-card-text> 
            <v-dialog v-model="dialogGrid.status" fullscreen hide-overlay >              
              <v-card>
                <v-toolbar dense dark :color="dialogGrid.color">
                  <v-btn icon dark @click="dialogGrid.status = false">
                    <v-icon>keyboard_backspace</v-icon>
                  </v-btn>
                  <v-toolbar-title>Preview</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark flat @click="print()"><v-icon left>print</v-icon> Print</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-card class="printcontent">
                    <v-card-text :set="no=1">
                      <h2  class="text-xs-center">Preview Lokasi Ujian <strong>{{gedungs.find(x=>x.id==filter.gedung_id)?gedungs.find(x=>x.id==filter.gedung_id).nama:''}}</strong> ruangan <strong>{{dialogGrid.ruang.nama}}</strong></h2>
                    </v-card-text>
                    <v-divider/>
                    <v-card-text class="block2"  :set2="start1=true">  
                      <table style="width:100%">
                        <tbody>
                          <template>
                            <tr v-for="(n) in 20" :key="n" v-if="start1">
                              <template v-for="(j) in 5" v-if="no <= dialogGrid.ruang.kapasitas">                                
                                <td valign="top" class="text-xs-center" :key="j" :set="start1 = no<=dialogGrid.ruang.kapasitas? true :false">
                                  <template v-if="dialogGrid.ruang.calons[no-1]">                                                                    
                                    <div style="border:1px solid #000; height:80px; width:80px; margin:auto">
                                      <img style="height:100%" :src="$config.file+'user-thumb?reff_id='+dialogGrid.ruang.calons[no-1].user_id" /><br/>
                                    </div>
                                    <span>                                      
                                      <strong>{{dialogGrid.ruang.calons[no-1].number}}</strong><br/>
                                      <small>{{dialogGrid.ruang.calons[no-1].nama.substring(0, 40)}}</small>
                                    </span>                                                                          
                                  </template>  
                                  <template v-else>
                                    <span style="font-size:8px" class="grey--text">{{no}}</span>
                                  </template>                                    
                                  <span :set="no++"></span>
                                </td>
                              </template>
                            </tr>
                          </template>                          
                        </tbody>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-dialog>           
            <v-dialog v-model="dialogList.status" fullscreen hide-overlay >              
              <v-card>
                <v-toolbar dense dark :color="dialogList.color">
                  <v-btn icon dark @click="dialogList.status = false">
                    <v-icon>keyboard_backspace</v-icon>
                  </v-btn>
                  <v-toolbar-title>Preview</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark flat @click="print()"><v-icon left>print</v-icon> Print</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-card class="printcontent">
                    <v-card-text :set="no=1">
                      <h2 class="text-xs-center">Absensi Ujian <strong>{{gedungs.find(x=>x.id==filter.gedung_id)?gedungs.find(x=>x.id==filter.gedung_id).nama:''}}</strong> ruangan <strong>{{dialogList.ruang.nama}}</strong></h2>
                    </v-card-text>
                    <v-divider/>
                    <v-card-text class="block2">  
                      <table style="width:100%">
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>Nama</th>
                            <th>Nomor</th>
                            <th>Tanda Tangan</th>                            
                          </tr>
                        </thead>
                        <tbody>
                          <template>
                            <tr v-for="(calon, n) in dialogList.ruang.calons" :key="n">
                              <td valign="top" style="width:20px">{{n+1}}</td>
                              <td valign="top" style="width:270px">{{calon.nama.substring(0,35)}}</td>
                              <td valign="top" class="text-xs-center" style="width:100px">{{calon.number}}</td>          
                              <td valign="top" style="width:270px"></td>
                            </tr>
                          </template>                          
                        </tbody>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-dialog>           
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/admin/models/Gedung';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      gedungs : [],
      gedung : {},
      filter  : { gedung_id: null },
      loading : false,
      dialogGrid : {
        color : 'green',
        status : false,        
        ruang : {},
      },
      dialogList : {
        color : 'green',
        status : false,        
        ruang : {},
      },

    }),  
    watch:{
      
    },
    mounted(){ 
      this.$watch(['filter','gedung_id'].join('.'), (newId)=>{        
        this.loading = true;
        model.gedung({id:newId}).then(data=>{
          this.gedung = data;
          this.loading = false;
        })                  
      });
      this.loading = true;
      model.gedungs().then(data=>{
        this.gedungs = data; this.filter.gedung_id = this.gedungs[0]?this.gedungs[0].id:null
        this.loading = false;
      });
      
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        openDialogGrid(color, ruang, no){
          this.dialogGrid.status = true;
          this.dialogGrid.color  = color;
          this.dialogGrid.ruang  = ruang;
        },

        openDialogList(color, ruang, no){
          this.dialogList.status = true;
          this.dialogList.color  = color;
          this.dialogList.ruang  = ruang;
        },         

        print(){
          window.scrollTo({ top: 0 });
          setTimeout(()=>{print();}, 100);
        }
    }
}
</script>
<style>
.block table td, .block table th {
  padding: 5px 5px;
  border: 1px solid black;
}  
.block table{  
  border-collapse: collapse;
}

.block2 table td, .block2 table th {
  padding: 5px 5px;
  border: 1px solid black;
}  
.block2 table{  
  border-collapse: collapse;
  font-size: 12px;
}
.psrintcontent * {visibility: hidden; color:#000;}  
.prsintcontent {position : fixed; top:0px; left:0px; z-index: -1}  

@media print
{    
    body * {visibility:hidden;}
    .v-card {height:0px !important;}
    .printcontent * {visibility : visible;}
    .printcontent {position : fixed; top:0px; left:0px;}
}
</style>